<!--头部-->
<template>
  <div class="header-container">
    <!-- 左边 -->
    <div class="header-left">
      <img :src="Logo" class="logo-img" />
      <span class="system-title ml10">{{ systemTitle }}</span>
    </div>

    <!-- 中间 -->
    <div class="header-center">
      <a-space size="large">
        <router-link
          v-for="item in topbarRouters"
          :key="item.key"
          :to="item.path"
          v-show="!item.hidden"
          class="menu-item"
          @click="selectedRoute(item.path)"
        >
          <component
            :is="item.icon"
            class="menu-icon"
            :style="selected === item.path ? activeStyle : defaultStyle"
          />
          <span
            :style="selected === item.path ? activeStyle : defaultStyle"
            class="menu-text"
          >
            {{ item.label }}
          </span>
        </router-link>

        <!-- <a-dropdown
          trigger="click"
          :overlay-style="{ minWidth: '120px' }"
        >
          <span
            :class="['menu-system', isSystemMenuActive ? 'system-highlight' : '']"
            @click="selectedRoute('system')"
            class="menu-text"
          >
            <BarsOutlined class="menu-icon"/>
            系统管理
            <DownOutlined />
          </span>
          <template #overlay>
            <a-menu
              :selected-keys="[selectedKey]"
              @select="handleSelect"
              class="system-dropdown-menu"
            >
              <a-menu-item
                v-for="item in systemMenuItems"
                :key="item.key"
                @click="item.handler"
                class="system-menu-item"
              >
                <component :is="item.icon" class="mr10" />
                {{ item.text }}
              </a-menu-item>
            </a-menu>
          </template>
</a-dropdown> -->
      </a-space>
    </div>

    <!-- 右边 -->
    <div class="header-right">
      <a-popover
        v-model:visible="alertPopoverVisible"
        trigger="click"
        placement="bottomRight"
        overlayClassName="alert-popover"
        :getPopupContainer="(triggerNode) => triggerNode.parentNode"
      >
        <template #content>
          <div class="alert-list-container">
            <a-button type="link" @click="alarmMarkRead" class="all-header" v-if="unreadCountList.length > 0">一键已读</a-button>
            <!-- 卡片列表 -->
            <div v-if="unreadCountList.length > 0" class="alert-cards">
              <a-card
                v-for="item in unreadCountList"
                :key="item.id"
                size="small"
                class="alert-card"
                :body-style="{ padding: '12px' }"
              >
              <div class="tag-header">
                <a-tag :color="alarmLevelConfig[item.firstMessage?.alarmLevel]?.color || 'gray'" class="mb5">
                  {{ alarmLevelConfig[item.firstMessage?.alarmLevel]?.text || '未知' }}
                </a-tag>
                <a-button type="link" @click="alarmRead(item.id)">已读</a-button>
              </div>

                <div class="alert-card-header">
                  <span class="alert-time">{{ item.firstMessage?.alarmTime || item.time }}</span>
                </div>
                <div class="alert-content">{{ item.firstMessage?.alarmMessage }}</div>
              </a-card>
            </div>
            <div v-else class="empty-tip">暂无未读告警</div>

            <!-- 分页 -->
            <div class="pagination-wrapper">
              <a-pagination
                v-model:current="unreadCountPagination.current"
                v-model:pageSize="unreadCountPagination.pageSize"
                :total="unreadCountPagination.total"
                :pageSizeOptions="['5', '10', '20']"
                showSizeChanger
                @change="onAlertPageChange"
                @showSizeChange="onAlertPageSizeChange"
                size="small"
              />
            </div>
          </div>
        </template>

        <a-badge :count="unreadCount" :overflow-count="99" :number-style="{backgroundColor: '#FF4D4F', color: '#fff', boxShadow: '0 0 0 1px #d9d9d9 inset', padding: 0, fontSize: '11px'}">
          <AlertOutlined class="icon-button color-fff" />
        </a-badge>
      </a-popover>

      <div v-for="(menu,index) in topbarMenu" :key="index">
        <a-tooltip :title="menu.label" placement="bottom" >
          <BarChartOutlined class="icon-button" @click="openBigScreen(menu)" v-if="auth.hasPermi(['topbar:bigScreen'])"/>
        </a-tooltip>
      </div>
      <!-- <a-tooltip title="移动端" placement="bottom" >
        <InsertRowBelowOutlined class="icon-button" @click="openMobileSite" />
      </a-tooltip> -->

      <a-popover v-model:visible="mobileVisivle" trigger="click" :width="300" v-if="auth.hasPermi(['topbar:app'])">
        <template #content>
          <div class="platform-container">
            <div class="platform-item">
              <div class="item-header cur-p" @click="openMobileSite('H5')">
                <IeOutlined class="icon mr5" />
                <span class="title">H5端</span>
                <RightOutlined class="arrow-icon" />
              </div>
            </div>

            <div class="platform-item">
              <div class="item-header cur-p" @click="openMobileSite('APP')">
                <MobileOutlined class="icon mr5" />
                <span class="title">APP端</span>
                <RightOutlined class="arrow-icon" />
              </div>
            </div>

            <div class="platform-item">
              <div
                class="item-header cur-p"
                @click="isQrcodeShow = !isQrcodeShow"
              >
                <WechatOutlined class="icon mr5" />
                <span class="title">小程序</span>
                <Icon :type="isQrcodeShow ? 'up' : 'down'" class="arrow-icon" />
              </div>

              <!-- 二维码：默认隐藏，点击后展开 -->
              <transition name="fade-in-out">
                <div class="qrcode-container" v-if="isQrcodeShow">
                  <img
                    :src="wxHtml"
                    :width="110"
                    :height="110"
                    class="qrcode"
                    alt="小程序二维码"
                  />
                  <span class="qrcode-tip">扫码打开小程序</span>
                </div>
              </transition>
            </div>
          </div>
        </template>
        <InsertRowBelowOutlined class="icon-button cur-p" @click="openMobile" />
      </a-popover>

      <a-dropdown
        :trigger="['click']"
        placement="bottomRight"
        @visibleChange="handleDropdownVisibleChange"
      >
        <div class="user-info">
          <img
            class="user-avatar"
            :src="currentUserAvatarUrl"
            @error="handleAvatarError"
            alt="用户头像"
          />
          <span class="username">
            {{ username }}
            <component
              :is="isDropdownOpen ? UpOutlined : DownOutlined"
              class="dropdown-arrow"
            />
          </span>
        </div>
        <template #overlay>
          <a-menu class="user-dropdown-menu">
            <a-menu-item
              v-for="item in systemMenuItems"
              :key="item.key"
              @click="item.handler"
            >
              <component :is="item.icon" />
              {{ item.label }}
            </a-menu-item>
            <!-- <a-menu-item key="project" @click="navigateToProject">
              <ClusterOutlined />
              <span>项目管理</span>
            </a-menu-item>
            <a-menu-item key="profile" @click="navigateToProfile">
              <UserOutlined />
              <span>个人中心</span>
            </a-menu-item>
            <a-menu-item key="firmware" @click="navigateToFirmware">
              <AppstoreOutlined />
              <span>固件管理</span>
            </a-menu-item> -->
            <!-- <a-menu-item key="manage" @click="handleOpenDict">
              <cluster-outlined />
              <span style="margin-left: 6px">字典</span>
            </a-menu-item> -->
            <!-- <a-menu-item key="manage" @click="handleOpenManage" v-if="auth.hasPermi(['topbar:backend'])">
              <cluster-outlined />
              <span style="margin-left: 6px">管理后台</span>
            </a-menu-item> -->
            <a-menu-item key="logout" @click="logout">
              <ExportOutlined />
              <span style="margin-left: 6px">退出登录</span>
            </a-menu-item>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed, onMounted, watch, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import cookies from 'vue-cookies'
import { getRoot } from '/@/root'
import { getSystemTitle, logoutMethod, getUserInfo } from '/@/api/manage'
import { getOrgData, getUserQualification } from '/@/api/user'
import { CURRENT_CONFIG } from '/@/api/http/config'
import { NAV_OPTIONS, SYSTEM_MENU_CONFIG } from '/@/types/constants'
import { ELocalStorageKey, ERouterName, SystemTitleKey } from '/@/types'
import Logo from '/@/assets/icons/logo/zklt.png'
import UserIcon from '/@/assets/images/user.png'
import UserErrorIcon from '/@/assets/images/user_error.png'
import Icon, {
  BarChartOutlined,
  ClusterOutlined,
  WechatOutlined,
  ExportOutlined,
  MobileOutlined,
  DownOutlined,
  IeOutlined,
  RightOutlined,
  UpOutlined,
  InsertRowBelowOutlined,
} from '@ant-design/icons-vue'
import { getContentList } from '/@/api/algCode'
import useAppStore from '/@/store/pinia/app'
import { useMyStore } from '/@/store'
import auth from '/@/plugins/auth'
import { getAlarmAllUnreadRead, getAlarmUnreadCount, getAlarmUnreadPage, getAlarmUnreadRead } from '/@/api/insp/insp-alarm'

// 路由实例
const route = useRoute()
const root = getRoot()
const store = useMyStore()

const alarmLevelConfig = {
  1: { text: '一级', color: 'red' },
  2: { text: '二级', color: 'orange' },
  3: { text: '三级', color: 'blue' }
}

const topbarRouters = computed(() => store.state.topbarRouters)
const topbarMenu = computed(() => store.state.topbarRouter)
const sidebarRouters = computed(() => store.state.sidebarRouters)
const username = ref('')
const currentUserAvatarUrl = ref('')
const fetchUsername = async () => {
  const res = await getUserInfo()
  if (res.code === 0 && res.data) {
    username.value = res.data.username || ''
    if (
      res.data.files &&
      Array.isArray(res.data.files) &&
      res.data.files.length > 0
    ) {
      currentUserAvatarUrl.value = res.data.files[0].url
    } else {
      currentUserAvatarUrl.value = UserIcon
    }
  } else {
    message.warning('获取用户失败')
    username.value = '用户异常'
    currentUserAvatarUrl.value = UserErrorIcon
  }
}

const selected = ref('')
const selectedKey = ref('')
const isDropdownOpen = ref(false)
const userInfo = ref<Record<string, any>>({})
const orgInfo = ref<Record<string, any>>({})
const pilotList = ref<any[]>([])

const mobileVisivle = ref(false)
const isQrcodeShow = ref(false)

const openMobileSite = (platform) => {
  mobileVisivle.value = false // 关闭气泡卡片
  console.log(`打开${platform}端链接`, platform)
  if (platform === 'H5') {
    window.open(h5Html.value.replace('<p>', '').replace('</p>', ''), '_blank')
  } else if (platform === 'APP') {
    window.open(appHtml.value.replace('<p>', '').replace('</p>', ''), '_blank')
  }
}

const appHtml = ref('')
const h5Html = ref('')
const wxHtml = ref('')

const getAppHtml = async () => {
  const params = {
    categoryCode: 'inner_link',
  }
  const res = await getContentList(params)

  res.data.forEach((item) => {
    if (item.contentCode === 'weichat') {
      // wxHtml 取 attachments[0].url
      wxHtml.value = item.attachments?.[0]?.url || ''
    } else if (item.contentCode === 'app') {
      appHtml.value = item.content || ''
    } else if (item.contentCode === 'h5') {
      h5Html.value = item.content || ''
    }
  })
}

const openMobile = () => {
  isQrcodeShow.value = false // 打开气泡时默认隐藏二维码
  mobileVisivle.value = true
}

// 样式常量
const activeStyle = { color: '#2d8cf0' }
const defaultStyle = { color: 'white' }

const isSystemMenuActive = computed(() => {
  return (
    selected.value === 'system' ||
    [
      `/${ERouterName.MEMBERS}`,
      `/${ERouterName.DICT}`,
      `/${ERouterName.THIRD_APP}`,
      `/${ERouterName.MENU}`,
      `/${ERouterName.ROLE}`,
      `/${ERouterName.INST_LOG}`,
    ].includes(route.path)
  )
})

// 导航选项
const navOptions = NAV_OPTIONS

// 系统菜单项
const systemMenuItems = sidebarRouters.value.map((item) => ({
  ...item,
  handler: () => navigateTo(item.path),
}))

// 获取用户userId
const userId = localStorage.getItem(ELocalStorageKey.UserId)!

// 打开可视化大屏
const openBigScreen = (menu) => {
  if (userId) {
    const queryString = `userId=${userId}`
    const encryptedQuery = btoa(encodeURIComponent(queryString))
    window.open(`${menu.path}?p=${encryptedQuery}`, '_blank')
    // window.open(`https://www.zstkj.top/big-screen/#/auto-login?p=${encryptedQuery}`, '_blank')
    // window.open(`https://www.zstkj.top:8443/big-screen/#/auto-login?p=${encryptedQuery}`, '_blank')
    // window.open(`http://192.168.110.63:5173/big-screen/#/auto-login?p=${encryptedQuery}`, '_blank')
  } else {
    message.warning('用户信息不存在，请重新登录')
  }
}

// 方法
const updateSelectedState = () => {
  // 检查是否匹配常规路由
  const matchedOption = navOptions.find((item) => route.path === item.path)
  if (matchedOption) {
    selected.value = matchedOption.path
    selectedKey.value = ''
    return
  } else {
    if (
      [
        '/scenario-plan-detail',
        '/' + ERouterName.SCENARIO,
        '/' + ERouterName.SCENARIO_ICON,
        '/' + ERouterName.SCENARIO_WORKSPACE,
        '/' + ERouterName.SCENARIO_PLAN,
      ].includes(route.path)
    ) {
      selected.value = '/' + ERouterName.SCENARIO
      selectedKey.value = ''
      return
    }
  }

  // 检查是否为系统管理子页面
  const systemRoutes: Record<string, string> = {
    [ERouterName.MEMBERS]: 'member',
    [ERouterName.DICT]: 'dictionary',
    [ERouterName.MENU]: 'menu',
    [ERouterName.ROLE]: 'role',
    [ERouterName.INST_LOG]: 'log',
  }

  for (const [routeName, key] of Object.entries(systemRoutes)) {
    if (route.path === `/${routeName}`) {
      selected.value = 'system'
      selectedKey.value = key
      return
    }
  }

  // 默认选中第一个选项
  selected.value = navOptions[0].path
  selectedKey.value = ''
}

const jumpToPlatform = () => {
  const targetUrl = 'http://www.zstkj.top:8003/login?redirect=%2Findex'
  const newWindow = window.open(targetUrl, 'targetSiteWindow')

  if (!newWindow) {
    message.warning('弹出窗口被浏览器阻止，请允许弹出窗口后重试。')
    return
  }

  // 延时发送消息，确保目标页面已加载
  setTimeout(() => {
    newWindow.postMessage(
      {
        type: 'LOGIN_REQUEST',
      },
      'http://www.zstkj.top:8080',
    )
  }, 1000)
}

const selectedRoute = (path: string) => {
  console.log(path)
  selected.value = path
  if (path !== 'system') {
    selectedKey.value = ''
  }
}

const handleSelect = ({ key }: { key: string }) => {
  selectedKey.value = key
  selected.value = 'system'

  const routeMap: Record<string, string> = {
    member: ERouterName.MEMBERS,
    dictionary: ERouterName.DICT,
    menu: ERouterName.MENU,
    role: ERouterName.ROLE,
    log: ERouterName.INST_LOG,
  }

  if (routeMap[key]) {
    root.$router.push(routeMap[key])
  }
}

const handleDropdownVisibleChange = (visible: boolean) => {
  isDropdownOpen.value = visible
}

const handleOpenManage = () => {
  if (userId) {
    const queryString = `userId=${userId}`
    const encryptedQuery = btoa(encodeURIComponent(queryString))
    window.open(`${CURRENT_CONFIG.baseUAVURL}?a=${encryptedQuery}`, '_blank')
    // window.open(`https://zstkj.top/uav/?a=${encryptedQuery}`, '_blank')
    // window.open(`https://zstkj.top:8443/uav/?a=${encryptedQuery}`, '_blank')
  } else {
    message.warning('用户信息不存在，请重新登录')
  }
}

/* const handleOpenDict = () => {
  root.$router.push(`/${ERouterName.DICT}`)
} */
const logout = async () => {
  try {
    const res = await logoutMethod()
    if (res.code === 0) {
      localStorage.clear()
      store.commit('SET_LOGOUT')
      cookies.remove(ELocalStorageKey.Token)
      root.$router.push(`/${ERouterName.PROJECT}`)
      message.success('退出登录成功')
    }
  } catch (error) {
    message.error('退出登录失败')
  }
}

const navigateTo = (routeName: string) => {
  if (routeName.startsWith('http')) {
    const queryString = `userId=${userId}`
    const encryptedQuery = btoa(encodeURIComponent(queryString))
    window.open(`${routeName}?a=${encryptedQuery}`, '_blank')
  } else {
    root.$router.push({ path: routeName })
  }
}

const navigateToProject = () => navigateTo(ERouterName.ORG)
const navigateToProfile = () => navigateTo(ERouterName.USER)
const navigateToFirmware = () => navigateTo(ERouterName.FIRMWARES)

const handleAvatarError = (e: Event) => {
  (e.target as HTMLImageElement).src =
    'https://picsum.photos/200/200?random=avatar'
}

const fetchUserData = async () => {
  try {
    const res = await getUserInfo()
    if (res && res.code === 0) {
      userInfo.value = res.data

      // 获取组织信息
      if (userInfo.value.workspace_id) {
        const orgRes = await getOrgData(userInfo.value.workspace_id)
        orgInfo.value = orgRes.data
      }

      // 获取用户资质信息
      if (userInfo.value.user_id) {
        const qualificationRes = await getUserQualification(
          userInfo.value.user_id,
        )
        if (qualificationRes && qualificationRes.code === 0) {
          pilotList.value = qualificationRes.data
        }
      }
    }
  } catch (error) {
    console.error('获取用户数据失败:', error)
  }
}

const systemTitle = ref(localStorage.getItem(SystemTitleKey.SystemTitle) || '')
const fetchSystemTitle = async () => {
  try {
    const res = await getSystemTitle(CURRENT_CONFIG.systemTitle)
    systemTitle.value = res.data
    localStorage.setItem(SystemTitleKey.SystemTitle, res.data)
  } catch (error) {
    console.error('获取系统标题失败:', error)
  }
}

// 监听路由变化
watch(() => route.path, updateSelectedState)

const unreadCount = ref('')

const alertPopoverVisible = ref(false)
const unreadCountList = ref<any[]>([])
const unreadCountPagination = reactive({
  pageSizeOptions: ['10', '20', '50', '100'],
  showQuickJumper: true,
  showSizeChanger: true,
  pageSize: 10,
  current: 1,
  total: 0,
  showTotal: (total: number) => `总计 ${total} 条`
})

const fetchUnreadData = async (page = 1, pageSize = 5) => {
  const paramQuery = {
    page: page,
    pageSize: pageSize,
    param: {
      views: 0,
      bizCode: 'alarm_msg',
      userId: userId
    }
  }
  const res = await getAlarmUnreadPage(paramQuery)
  // console.log('res.data.list.value', res.data.list)

  const list = (res.data.list || []).map(item => {
    let parsedMessages = [] // 最终存储解析后的消息数组（每个元素是一个对象）

    try {
      const raw = item.message
      if (!raw) {
        parsedMessages = []
      } else {
        // 1. 解析外层 JSON
        const outer = typeof raw === 'string' ? JSON.parse(raw) : raw

        // 2. 提取 data 字段
        let data = outer.data
        if (data == null) {
          parsedMessages = []
        } else if (typeof data === 'string') {
          // 3. 如果 data 是字符串，再解析一次
          try {
            data = JSON.parse(data)
          } catch (e) {
            // 如果解析失败，将整个 data 作为一条消息
            parsedMessages = [{ rawData: data }]
            return { ...item, parsedMessages, firstMessage: parsedMessages[0] }
          }
        }

        // 4. 现在 data 可能是对象或数组
        if (Array.isArray(data)) {
          parsedMessages = data
        } else if (data && typeof data === 'object') {
          parsedMessages = [data] // 单个对象转数组
        } else {
          parsedMessages = []
        }
      }
    } catch (error) {
      parsedMessages = []
    }

    // 提取第一条消息（方便模板直接使用）
    const firstMessage = parsedMessages.length > 0 ? parsedMessages[0] : null

    return { ...item, parsedMessages, firstMessage }
  })

  unreadCountList.value = list
  unreadCountPagination.total = res.data.pagination?.total || 0
  unreadCount.value = res.data.pagination?.total || 0
  unreadCountPagination.current = page
  unreadCountPagination.pageSize = pageSize
}

const onAlertPageChange = (page: number, pageSize: number) => {
  fetchUnreadData(page, pageSize)
}

const onAlertPageSizeChange = (current: number, size: number) => {
  // 改变每页条数时重置到第一页
  fetchUnreadData(1, size)
}

// 监听 popover 显示，打开时加载数据（若未加载过）
watch(alertPopoverVisible, (visible) => {
  if (visible && unreadCountList.value.length === 0) {
    fetchUnreadData(unreadCountPagination.current, unreadCountPagination.pageSize)
  }
})

const alarmRead = async (id) => {
  getAlarmUnreadRead(id).then(res => {
    if (res.code === 0) {
      fetchUnreadData(1, 5)
    }
  })
}

const alarmMarkRead = async () => {
  getAlarmAllUnreadRead().then(res => {
    console.log('3333', res)
    if (res.code === 0) {
      fetchUnreadData(1, 5)
    }
  })
}

onMounted(() => {
  updateSelectedState()
  updateSelectedState()
  fetchUserData()
  fetchSystemTitle()
  getSystemTitle(CURRENT_CONFIG.systemTitle).then((res) => {
    console.log(res)
    systemTitle.value = res.data
  })
  fetchUsername()
  getAppHtml()
  fetchUnreadData()
})
</script>

<style lang="scss" scoped>
.header-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
  background-color: #001529;
  color: white;
}

.header-left {
  display: flex;
  align-items: center;

  .logo-img {
    width: 30px;
    height: 30px;
  }

  .system-title {
    font-weight: 600;
    font-size: 24px;
  }
}

.header-center {
  .menu-item {
    display: flex;
    align-items: center;
    text-decoration: none;

    &:hover {
      opacity: 0.8;
    }
  }

  .menu-system {
    cursor: pointer;
    color: #fff !important;
    display: flex;
    align-items: center;

    &:hover {
      opacity: 0.8;
    }

    &.system-highlight {
      color: #2d8cf0 !important;

      .menu-icon {
        color: #2d8cf0 !important;
      }
    }

    .menu-icon {
      color: white !important;
      margin-right: 8px;
    }
  }

  .menu-icon {
    font-size: 16px;
    margin-right: 8px;
  }

  .menu-text {
    font-size: 16px;
  }
}

.header-right {
  display: flex;
  align-items: center;
  gap: 16px;

  .icon-button {
    font-size: 18px;
    cursor: pointer;

    &:hover {
      color: #2d8cf0;
    }
  }

  .user-info {
    display: flex;
    align-items: center;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }

    .user-avatar {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 8px;
      object-fit: cover;
    }

    .username {
      display: flex;
      align-items: center;
    }

    .dropdown-arrow {
      margin-left: 4px;
      font-size: 12px;
    }
  }
}

// 系统下拉菜单样式 - 白色背景，黑色字体
.system-dropdown-menu {
  background-color: #ffffff !important;
  border: 1px solid #d9d9d9 !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1);

  :deep(.ant-menu-item) {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    color: #000000 !important;
    background-color: #ffffff !important;
    transition: background-color 0.2s;

    &:hover {
      background-color: #e6f7ff !important;
      color: #000000 !important;
    }

    .anticon {
      color: #000000 !important;
      margin-right: 8px;
    }
  }

  :deep(.ant-menu-item-selected) {
    background-color: #e6f7ff !important;
    color: #000000 !important;
    font-weight: 500;
  }
}

// 用户下拉菜单样式
.user-dropdown-menu {
  :deep(.ant-menu-item) {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.qrcode-img {
  width: 160px;
  height: 160px;
}

.platform-container {
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

/* 单个平台项：纵向排列，居中对齐，固定宽度 */
.platform-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100px;
  padding: 8px 0;
}

/* 标题区域：hover效果+点击反馈，统一高度 */
.item-header {
  display: flex;
  align-items: center;
  justify-content: center;
  /* 标题+图标居中 */
  // width: 100%;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  color: #1f2937;
  transition: all 0.3s;
  /* 过渡动画，更丝滑 */
}

/* 点击区域hover效果：背景色+轻微上浮 */
.item-header:hover {
  background-color: #f0f9ff;
  transform: translateY(-2px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 图标样式统一 */
.icon {
  font-size: 18px;
  color: #1890ff;
}

/* 箭头图标：次要视觉，颜色稍浅 */
.arrow-icon {
  font-size: 14px;
  color: #6b7280;
  margin-left: 6px;
  transition: transform 0.3s;
  /* 箭头切换动画 */
}

/* 二维码容器：居中显示，与标题间距适中 */
.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 12px;
  padding: 10px;
  background-color: #f9fafb;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  width: 100%;
}

/* 二维码样式：精致化处理 */
.qrcode {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 4px;
  background-color: #fff;
}

/* 二维码提示文本：灰色小字，居中 */
.qrcode-tip {
  font-size: 12px;
  color: #6b7280;
  margin-top: 8px;
  text-align: center;
}

/* 过渡动画：二维码显示/隐藏更自然 */
.fade-in-out-enter-from,
.fade-in-out-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-in-out-enter-active,
.fade-in-out-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}

// 在 <style scoped> 中添加
.alert-list-container {
  min-width: 320px;
  max-width: 400px;
  max-height: 400px;
  display: flex;
  flex-direction: column;
}

.all-header {
  margin-left: auto;
}

.alert-cards {
  flex: 1;
  overflow: auto;
  margin-bottom: 12px;

  .alert-card {
    margin-bottom: 8px;
    border-radius: 6px;
    border: 1px solid #f0f0f0;

    .tag-header {
      display: flex;
      justify-content: space-between;
    }

    .alert-card-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 4px;

      .alert-title {
        font-weight: 500;
        color: #1f2937;
      }

      .alert-time {
        font-size: 12px;
        color: #9ca3af;
      }
    }

    .alert-content {
      font-size: 14px;
      color: #4b5563;
      overflow: hidden;
      text-overflow: ellipsis;
      // white-space: nowrap;
    }
  }
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
  border-top: 1px solid #f0f0f0;
}

.empty-tip {
  text-align: center;
  padding: 20px 0;
  color: #9ca3af;
}
</style>
